let configs = window.__env || {};

configs.defaultDebounce = 770;
configs.val_version = '4.2.2';
configs.env = configs.env || 'local';
configs.auth_method = configs.auth_method || '';
configs.keycloak_url =
  configs.keycloak_url || 'https://kc-dev.ambevdevs.com.br';
configs.keycloak_client_id =
  configs.keycloak_client_id || 'abi-gth-sensory-one';
configs.keycloak_client_secret_internal =
  configs.keycloak_client_secret_internal || '';
configs.keycloak_client_secret_external =
  configs.keycloak_client_secret_external || '';
configs.keycloak_realm_internal = configs.keycloak_realm_internal || 'Ambev';
configs.keycloak_realm_external = configs.keycloak_realm_external || 'Third';
if (window.location.host.indexOf('localhost') > -1) {
  configs.auth_method = configs.auth_method || 'keycloak';
  configs.defaultUrl = 'http://localhost:3000';
  configs.file_api_url =
    configs.file_api_url || 'http://localhost:2124/api/v1/file-manage';
  configs.file_api_static_url =
    configs.file_api_static_url || 'http://localhost:2124/api/v1/file-manage';
  configs.user_api_url =
    configs.user_api_url || 'http://localhost:2120/api/v1/usermanagement';
  configs.sample_api_url =
    configs.sample_api_url || 'http://localhost:2118/api/v1/sample-manage';
  configs.brand_api_url =
    configs.brand_api_url || 'http://localhost:2116/api/v1/brand-manage';
  configs.package_api_url =
    configs.package_api_url || 'http://localhost:2117/api/v1/package-manage';
  configs.round_api_url =
    configs.round_api_url || 'http://localhost:2119/api/v1/round-manage';
  configs.group_api_url =
    configs.group_api_url || 'http://localhost:2115/api/v1/group-manage';
  configs.malt_varieties_api_url =
    configs.malt_varieties_api_url ||
    'http://localhost:2122/api/v1/malt-manage';
  configs.threshold_api_url =
    configs.threshold_api_url ||
    'http://localhost:2123/api/v1/threshold-manage';
  configs.triangle_api_url =
    configs.triangle_api_url || 'http://localhost:2127/api/v1/triangle-manage';
  configs.socket_servers_api_url =
    configs.socket_servers_api_url || 'ws://localhost:2126';
  configs.auth_api_url =
    configs.auth_api_url || 'http://localhost:2128/api/v1/auth-manage';
  configs.report_api_url =
    configs.report_api_url || 'http://localhost:2130/api/v1/report-manage';
}

configs = {
  ...configs,
  ...window.__env,
};

export default configs;

